import { WeezSocket } from "@weezevent/piglet";

WeezSocket.listen();

export const getParentUrl = async () => {
    let url = null;
    try {
        let pigletResponse = await WeezSocket.send(
            {
                type: "parent-url",
                origin: "neo",
            },
            { needs_answer: true },
        )
        url = new URL(pigletResponse.payload.parentUrl).toString();
    } catch (e) {
        console.error("Cannot get the parent URL, check if the iframe is properly integrated.");
    }
    return url;
};